// extracted by mini-css-extract-plugin
export default {"body":"APICallsHistory_body__fCql0","notFound":"APICallsHistory_notFound__E+ODv","pagination":"APICallsHistory_pagination__e5McY","searchInput":"APICallsHistory_searchInput__vj9O-"};